import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import Header from "../Header";
import Sidebar from "../SideBar";
import { User, Info, MapPin, Phone, StickyNote, ArrowLeftIcon, PenIcon, Trash2Icon } from "lucide-react";


const AdmissionDetail = () => {
    const { id } = useParams();
    const [customer, setCustomer] = useState(null);
    const navigate = useNavigate()
    const url = process.env.REACT_APP_LINK;
    const user = getDecryptedUserFromCookie("gta_mainstateuser");

    useEffect(() => {
        const fetchCustomer = async () => {
            try {
                const res = await fetch(`${url}/feepay/order/${id}`);
                const result = await res.json();
                const data = result.data;
                setCustomer(data);
            } catch (error) {
                console.error("Error loading customer:", error);
            }
        };

        if (id) fetchCustomer();
    }, [id]);

    if (!customer) return <p>Loading customer details...</p>;

    const { billingAddress, shippingAddress, contact } = customer;
    const firstContact = contact?.[0] || {};

    const handleEdit = (customer) => {
        navigate('/edit-admission', { state: customer });
    };

    const handleDelete = async (customerId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "This customer will be permanently deleted!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${url}/admission/${customerId}`, {
                        method: 'DELETE',
                    });

                    if (!response.ok) {
                        const err = await response.json();
                        throw new Error(err?.message || 'Failed to delete');
                    }

                    Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
                    // Redirect user back to customer list after delete
                    navigate('/admission');
                } catch (error) {
                    console.error('Delete error:', error.message);
                    Swal.fire('Error!', `Failed to delete customer. ${error.message}`, 'error');
                }
            }
        });
    };

    return (
        <>
            <div >
                <div className="ecom-customer-detail-container">
                    <div className="ecom-customer-header-detail">
                        <div className="ecom-customer-header-left-container">
                            <ArrowLeftIcon onClick={() => navigate('/admission')} /> <h2 className="ecom-customer-name-highlight">{customer.customerName}</h2>
                        </div>
                        <div className="ecom-customer-header-right-container">
                            <PenIcon onClick={() => handleEdit(customer)} />
                            <Trash2Icon onClick={() => handleDelete(customer.id)} />
                        </div>
                    </div>

                    {/* Personal Details */}
                    <section className="ecom-customer-section-box ecom-customer-details">
                        <h4><User size={16} style={{ marginRight: '8px' }} /> Personal Details</h4>
                        <div className="ecom-customer-detail-grid">
                            <div><label>Full Name:</label><span>{customer.paymentDetails.name}</span></div>
                            <div><label>Father Name:</label><span>{customer.paymentDetails.fatherName}</span></div>
                            <div><label>Mother Name:</label><span>{customer.paymentDetails.motherName}</span></div>
                            <div><label>Date of birth:</label><span> {customer.paymentDetails.dob
                                ? new Date(customer.paymentDetails.dob).toLocaleDateString("en-GB")
                                : "—"}</span></div>
                            <div><label>Aadhar Number:</label><span>{customer.paymentDetails.aadhar}</span></div>
                            <div><label>Gender:</label><span>{customer.paymentDetails.gender}</span></div>
                            <div><label>School:</label><span>{customer.paymentDetails.school}</span></div>



                        </div>
                    </section>

                    {/* Other Details */}
                    <section className="ecom-customer-section-box ecom-customer-details">
                        <h4><Info size={16} style={{ marginRight: '8px' }} /> Other Details</h4>
                        <div className="ecom-customer-detail-grid">
                            <div><label>Address:</label><span>{customer.paymentDetails.address || "—"}</span></div>
                            <div><label>Pincode:</label><span>{customer.paymentDetails.pincode || "—"}</span></div>
                            <div><label>Center:</label><span>{customer.paymentDetails.center || "—"}</span></div>
                            <div>
                                <label>Rules Agreed:</label>
                                <span>
                                    {customer.paymentDetails.rulesAgreed === "1"
                                        ? "Yes"
                                        : customer.paymentDetails.rulesAgreed === "0"
                                            ? "No"
                                            : "—"}
                                </span>
                            </div>
                            <div><label>User ID:</label><span>{customer.paymentDetails.user_id || "—"}</span></div>


                        </div>
                    </section>

                    {/* Address Details */}



                    {/* Contact Details */}
                    <section className="ecom-customer-section-box ecom-customer-details">
                        <h4><Phone size={16} style={{ marginRight: '8px' }} /> Contact Details</h4>
                        <div className="ecom-customer-detail-grid">

                            <div><label>Email:</label><span>{customer.paymentDetails.email || "—"}</span></div>
                            <div><label>Contact No.:</label><span>{customer.paymentDetails.mobile || "—"}</span></div>

                        </div>
                    </section>
                    {/* Cart Products Section */}
                    {/* Cart Products Section */}
                    <section className="ecom-customer-section-box ecom-customer-details">
                        <h4>Courses / Products</h4>
                        <div className="ecom-customer-detail-grid">
                            {customer.cart_products && JSON.parse(customer.cart_products).map((product, idx) => (
                                < >
                                    <div> <label>Course Name:</label>
                                        <span>{product.product_name}</span></div>
                                    <div>
                                        <label>Amount Paid:</label>
                                        <span>₹ {product.product_saleprice}</span>
                                    </div>

                                </>
                            ))}
                        </div>
                    </section>


                    {/* Remarks */}
                    {/* <section className="ecom-customer-section-box ecom-customer-details">
                        <h4><StickyNote size={16} style={{ marginRight: '8px' }} /> Remarks</h4>
                        <p className="remarks">{customer.remarks || "—"}</p>
                    </section> */}
                </div>
            </div>
        </>
    );
};

export default AdmissionDetail;
